(() => {
  const body = document.body;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const enabled = () => body.dataset.amMotion !== 'off' && !reduced.matches;
  const duration = () => Number(body.dataset.amDuration) || 650;
  const ease = 'cubic-bezier(.22,1,.36,1)';
  const active = new Set();
  const animate = (element, frames, options = {}) => {
    if (!enabled() || !element?.animate) return;
    const animation = element.animate(frames,{duration:duration(),easing:ease,...options});
    active.add(animation);
    animation.finished.then(() => active.delete(animation)).catch(() => active.delete(animation));
    return animation;
  };
  const watched = new WeakSet();
  const reveal = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      reveal.unobserve(entry.target);
      if (entry.target.getBoundingClientRect().bottom < 0) return;
      const distance = body.dataset.amMotion === 'expressive' ? 20 : 10;
      const siblings = [...entry.target.parentElement.children];
      const stagger = Math.min(Math.max(siblings.indexOf(entry.target),0),3)*(Number(body.dataset.amStagger)||0);
      animate(entry.target,[{opacity:0,transform:`translateY(${distance}px)`},{opacity:1,transform:'translateY(0)'}],{delay:stagger,fill:'backwards'});
    });
  },{threshold:0,rootMargin:'0px 0px 40px 0px'});
  function init(root = document) {
    if (!enabled() || window.Shopify?.designMode || body.dataset.amReveals !== 'true') return;
    root.querySelectorAll('.am-studio-section-heading,.am-studio-product,.am-studio-journal-grid article,.am-studio-purpose-mark,.am-studio-purpose-copy,.am-center,.am-how-heading,.am-how-media,.am-step,.am-reference-product,.am-lifestyle .am-card,.am-story .am-copy,.am-story-media,.am-partnership-panel,.am-faq-heading,.am-faq-item,.am-banner-inner').forEach(element => {
      if (watched.has(element)) return;
      watched.add(element);
      if (element.getBoundingClientRect().top < window.innerHeight) return;
      reveal.observe(element);
    });
  }
  init();
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll('*').forEach(element => reveal.unobserve(element)));
  const states = new WeakMap();
  const movingDetails = new Set();
  function toggleDetail(detail, open) {
    const content = detail.querySelector('.am-faq-answer,.am-hotspot-tip,.accordion__content');
    const summary = detail.querySelector('summary');
    if (!content || !summary) {detail.open = open;return;}
    const state = states.get(detail) || {revision:0,overflow:detail.style.overflow};
    const height = detail.getBoundingClientRect().height;
    const opacity = !detail.open && open ? '0' : getComputedStyle(content).opacity;
    state.revision += 1;
    const revision = state.revision;
    state.open = open;
    state.animation?.cancel();state.contentAnimation?.cancel();
    states.set(detail,state);movingDetails.add(detail);
    detail.open = true;
    const expanded = detail.getBoundingClientRect().height;
    const isHotspot = detail.matches('.am-hotspot');
    const collapsed = summary.getBoundingClientRect().height + (detail.matches('.am-faq-item') ? 2 : 0);
    if (!isHotspot) detail.style.overflow = 'clip';
    const finish = () => {
      if (state.revision !== revision) return;
      state.animation = null;state.contentAnimation?.cancel();state.contentAnimation = null;
      detail.open = open;detail.style.overflow = state.overflow;
      movingDetails.delete(detail);
    };
    state.contentAnimation = animate(content,[{opacity},{opacity:open ? 1 : 0}],{duration:duration()*.55,delay:open ? 70 : 0,fill:'both'});
    state.animation = isHotspot ? state.contentAnimation : animate(detail,[{height:`${height}px`},{height:`${open ? expanded : collapsed}px`}],{duration:Math.min(duration(),550),easing:'cubic-bezier(.4,0,.2,1)'});
    if (state.animation) state.animation.finished.then(finish).catch(() => {});
    else finish();
  }
  document.addEventListener('click',event => {
    const summary = event.target.closest('.am-faq-item>summary,.am-hotspot>summary,.product__accordion details>summary');
    if (!summary || !enabled() || body.dataset.amDisclosures !== 'true') return;
    event.preventDefault();
    const detail = summary.parentElement;
    const state = states.get(detail);
    toggleDetail(detail,!(state?.animation ? state.open : detail.open));
  });
  document.addEventListener('toggle',event => {
    const detail = event.target;
    if (!detail.matches('.am-faq-item,.am-hotspot,.product__accordion details')) return;
    const state = states.get(detail);
    if (!detail.open && state?.animation) {
      state.revision += 1;state.animation.cancel();state.contentAnimation?.cancel();
      state.animation = null;detail.style.overflow = state.overflow;movingDetails.delete(detail);
    }
  },true);
  const gallery = document.querySelector('media-gallery');
  if (gallery) {
    let previous = '', snapshot, pending = false;
    const fade = () => {
      pending = false;
      const image = gallery.querySelector('.product__media-item.is-active img:not(.am-gallery-crossfade)');
      if (!image || !image.complete || !image.naturalWidth) return;
      const key = image.currentSrc || image.src;
      if (previous === key) return;
      if (snapshot && enabled() && body.dataset.amProductImages === 'true') {
        gallery.querySelectorAll('.am-gallery-crossfade').forEach(el => el.remove());
        const outgoing = snapshot;
        outgoing.className = 'am-gallery-crossfade';outgoing.removeAttribute('id');outgoing.setAttribute('aria-hidden','true');outgoing.alt = '';
        const fit = getComputedStyle(image).objectFit;
        outgoing.style.cssText = `position:absolute;inset:0;width:100%;height:100%;object-fit:${fit};pointer-events:none;z-index:2;`;
        image.parentElement.append(outgoing);
        const animation = animate(outgoing,[{opacity:1},{opacity:0}],{easing:'cubic-bezier(.4,0,.2,1)'});
        if (animation) animation.finished.then(() => outgoing.remove()).catch(() => outgoing.remove());
        else outgoing.remove();
      }
      previous = key;snapshot = image.cloneNode(true);
    };
    fade();gallery.addEventListener('load',fade,true);
    new MutationObserver(() => {
      if (pending) return;
      pending = true;requestAnimationFrame(fade);
    }).observe(gallery,{subtree:true,childList:true,attributes:true,attributeFilter:['class','src','srcset']});
  }
  reduced.addEventListener('change',() => {
    if (!reduced.matches) return;
    reveal.disconnect();active.forEach(animation => animation.cancel());
    movingDetails.forEach(detail => {
      const state = states.get(detail);state.revision += 1;state.animation = null;
      detail.open = state.open;detail.style.overflow = state.overflow;
    });
    movingDetails.clear();
  });
})();



